import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import "./WorkExperience.scss";
import HCL from "../../assets/images/1577172593_oSU4c8_HCL_tech.jpg";
import TECH from "../../assets/images/tumblr_c2360ffb1173490a9496463a62e93d23_0fabc917_1280.jpg";
import TSF from "../../assets/images/experience-page/TSF.png";

function WorkExperience() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const experiences = [
        {
            id: 1,
            logo: HCL,
            jobTitle: "Software Engineer",
            companyName: "Actian (HCL Software)",
            dateRange: "Mar 2024 – Present",
            description: "Commercialized MKDE Stats utility using Java, converting internal developer tool to customer-facing version with memory usage, cache statistics, and worker thread monitoring. Implemented DBU API entry points using Java to expose memory usage statistics and performance counters. Enhanced zenenginestats utility (C++) by adding command-line options and fixing parameter parsing. Rewrote internal C program to Python for QueryPlanConverter utility with 100% accuracy. Fixed security vulnerabilities using Veracode static analysis and built reusable React.js components with hooks for enterprise diagnostic tools."
        },
        {
            id: 2,
            logo: TECH,
            jobTitle: "Full-Stack Developer Intern",
            companyName: "Techtonic Enterprises",
            dateRange: "Jul 2021 – Sep 2021",
            description: "Built e-commerce frontend using React.js and Tailwind CSS - product catalogs, shopping cart, and authentication interfaces. Integrated with Django REST APIs for product management and order processing. Implemented Razorpay payment gateway integration and product search with real-time filtering. Optimized component rendering and page load times as part of Agile team."
        },
        {
            id: 3,
            logo: HCL,
            jobTitle: "Backend Developer Intern",
            companyName: "HCL Technologies",
            dateRange: "July 2022 – August 2022",
            description: "Worked on a contract lifecycle management tool and learned to work with REST APIs and SQL. Implemented database solutions and optimized backend performance."
        },
        {
            id: 4,
            logo: TSF,
            jobTitle: "Web Development & Design Intern",
            companyName: "The Sparks Foundation",
            dateRange: "April 2021 – May 2021",
            description: "Learned Razorpay integration through API and connected it to web applications. Built responsive UI and enhanced user experience via modern design principles."
        }
    ];

    return (
        <Container fluid className="work-experience-section" id="experiences">
            <Container>
                <Row>
                    <Col xs={12}>
                        <div className="section-header text-center">
                            <h2 className="section-title">Work Experience</h2>
                            <p className="section-subtitle">My professional journey and achievements</p>
                        </div>
                    </Col>
                </Row>
                
                <Row className="g-4">
                    {experiences.map((experience, index) => (
                        <Col key={experience.id} lg={6} md={12} className="experience-col">
                            <Card className={`experience-card ${isVisible ? 'fade-in' : ''}`} 
                                  style={{ animationDelay: `${index * 0.2}s` }}>
                                <Card.Body className="d-flex">
                                    {/* Left Side - Logo */}
                                    <div className="logo-section">
                                        <div className="company-logo">
                                            <img 
                                                src={experience.logo} 
                                                alt={experience.companyName} 
                                                className="logo-image"
                                            />
                                        </div>
                                    </div>
                                    
                                    {/* Right Side - Job Details */}
                                    <div className="job-details">
                                        <h3 className="job-title">{experience.jobTitle}</h3>
                                        <h4 className="company-name">{experience.companyName}</h4>
                                        <div className="date-range">
                                            <i className="fas fa-calendar-alt"></i>
                                            {experience.dateRange}
                                        </div>
                                        <p className="description">{experience.description}</p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </Container>
    );
}

export default WorkExperience;
